module.exports = __webpack_public_path__ + "img/notice2.2906dd80.png";